export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_01.8d2f41d3.png";